class MtnQuote {
  constructor() {
    this.isSubmitting = false;
    this.products = null;
    this.PRODUCTS_KEY = 'mtn-quote-products';
    this.selectors = {
      count: document.querySelectorAll('[data-quote-count]'),
      productContainer: document.getElementById('mtn-quote-products'),
      emptyState: document.getElementById('mtn-quote-empty'),
      modalFormClear: document.getElementById('mtn-clear-form'),
      modal: document.getElementById('mtn-quote-modal'),
      modalFormShow: document.getElementById('mtn-show-form'),
      modalFormHide: document.getElementById('mtn-hide-form'),
      modalFormBody: document.getElementById('mtn-quote-modal-body'),
      modalSuccess: document.getElementById('mtn-quote-success'),
      modalSuccessBody: document.getElementById('mtn-quote-success-body'),
      modalSuccessHide: document.getElementById('mtn-hide-success'),
      form: document.getElementById('mtn-quote-form'),
    };

    this.updateState();
    this.registerEventListeners();
  }

  registerEventListeners() {

    addEventListener("storage", (event) => {
      this.updateState();
    });

    document.addEventListener('click', (function (event) {
      const addToQuoteBtn = event.target.closest('.mtn-quote-add-to-quote, .mtn-quote-add-to-quote-button');
      if (addToQuoteBtn) {
        const product = addToQuoteBtn.dataset;
        this.addRemoveFromQuote(product);
      }
    }).bind(this));

    const observer = new MutationObserver((function () {
      this.updateButtonsStatus();
    }).bind(this));
    const productGrid = document.querySelector('[data-testid="product-grid"]') || document.getElementById('ResultsList');
    if (productGrid) {
      observer.observe(productGrid, { childList: true, subtree: true });
    }

    if(this.selectors.modalFormClear) {
      this.selectors.modalFormClear.addEventListener('click', (function () {
        const confirmed = confirm("Do you really want to clear the list?");
        if(confirmed) {
          window.localStorage.setItem(this.PRODUCTS_KEY, "[]");
          this.updateState();
        }
      }).bind(this));
    }

    if(this.selectors.modalFormShow) {
      this.selectors.modalFormShow.addEventListener('click', (function () {
        this.selectors.modal.classList.add('_active')
      }).bind(this));
    }

    if(this.selectors.modalFormHide) {
      this.selectors.modalFormHide.addEventListener('click', (function () {
        this.selectors.modal.classList.remove('_active')
      }).bind(this));
    }

    if(this.selectors.modal) {
      this.selectors.modal.addEventListener('click', (function () {
        this.selectors.modal.classList.remove('_active')
      }).bind(this));
    }

    if(this.selectors.modalFormBody) {
      this.selectors.modalFormBody.addEventListener('click', (function (event) {
        event.stopPropagation()
      }).bind(this));
    }

    if(this.selectors.form) {
      this.selectors.form.addEventListener('submit', (function (event) {
        event.preventDefault();
        event.stopPropagation();
        if(this.validateForm() && !this.isSubmitting) {
          this.isSubmitting = true;
          this.selectors.form.classList.add('_loading')
          this.submitForm();
        }
      }).bind(this));
    }

    if(this.selectors.form) {
      this.selectors.form.addEventListener('input', (function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.hideError(event.target);
        if(event.target.name === 'zip') {
          event.target.value = event.target.value.replaceAll(/[^0-9-]/gi,'');
        }
      }).bind(this));
    }

    if(this.selectors.modalSuccess) {
      this.selectors.modalSuccess.addEventListener('click', (function () {
        this.selectors.modalSuccess.classList.remove('_active')
      }).bind(this));
    }

    if(this.selectors.modalSuccessHide) {
      this.selectors.modalSuccessHide.addEventListener('click', (function () {
        this.selectors.modalSuccess.classList.remove('_active')
      }).bind(this));
    }

    if(this.selectors.modalSuccessBody) {
      this.selectors.modalSuccessBody.addEventListener('click', (function (event) {
        event.stopPropagation()
      }).bind(this));
    }
  }

  hideError(field) {
    if(field.nextElementSibling && field.nextElementSibling.classList.contains('mtn-quote-modal__error')) {
      field.nextElementSibling.classList.remove('_active');
    }
  }

  showError(field, message) {
    if(field.nextElementSibling && field.nextElementSibling.classList.contains('mtn-quote-modal__error')) {
      field.nextElementSibling.classList.add('_active');
      field.nextElementSibling.textContent = message;
    }
  }

  validateForm() {
    let error = false

    if(this.selectors.form.elements.name.value.trim() === '') {
      error = true;
      this.showError(this.selectors.form.elements.name, "Enter sender name");
    }

    if(this.selectors.form.elements.email.value.trim() === '') {
      error = true;
      this.showError(this.selectors.form.elements.email, "Enter email");
    } else {
      if(!this.selectors.form.elements.email.value.match(/.+@.+\..+/i)) {
        error = true;
        this.showError(this.selectors.form.elements.email, "Enter valid email");
      }
    }

    if(this.selectors.form.elements.zip.value.trim() === '' || this.selectors.form.elements.zip.value.trim().length < 5) {
      error = true;
      this.showError(this.selectors.form.elements.zip, "Enter zip");
    }

    return !error;
  }

  readCookie(name) {
    if (typeof getCookie !== 'function') {
      return '';
    }

    try {
      return getCookie(name) || '';
    } catch (err) {
      console.warn(`Could not read cookie "${name}":`, err);
      return '';
    }
  }

  // Empty values are dropped so an existing Klaviyo profile is never overwritten with blanks
  buildProfileAttributes() {
    const attributes = { email: this.selectors.form.elements.email.value.trim() };
    const firstName = this.selectors.form.elements.name.value.trim();
    const company = this.selectors.form.elements.company.value.trim();
    const zip = this.selectors.form.elements.zip.value.trim();

    if (firstName) attributes.first_name = firstName;
    if (company) attributes.organization = company;
    if (zip) attributes.location = { zip: zip };

    return attributes;
  }

  // Server-to-server style call: works with or without cookie consent, klaviyo.js not required.
  async sendQuoteEvent(properties) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);

    try {
      const response = await fetch(
        'https://a.klaviyo.com/client/events?company_id=QQk4kQ',
        {
          method: 'POST',
          mode: 'cors',
          signal: controller.signal,
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: '2026-07-15',
          },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                properties: properties,
                metric: {
                  data: {
                    type: 'metric',
                    attributes: { name: 'Request a Quote' },
                  },
                },
                profile: {
                  data: {
                    type: 'profile',
                    attributes: this.buildProfileAttributes(),
                  },
                },
              },
            },
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Klaviyo responded ${response.status}: ${await response.text()}`);
      }
    } finally {
      clearTimeout(timeout);
    }
  }

  async submitForm () {
    if(!this.selectors.form) {
      return;
    }

    try {
      const eventProperties = {
        'FormName': 'Request a Quote',
        'ShareUrl': window.location.href,
        'SenderEmail': this.selectors.form.elements.email.value,
        'Company': this.selectors.form.elements.company.value,
        'SenderName': this.selectors.form.elements.name.value,
        'Note': this.selectors.form.elements.message.value,
        'ZipCode': this.selectors.form.elements.zip.value,
        'GetFirstUrl': this.readCookie('first_page'),
        'Products': this.products.filter((i)=>i.active),
        'utm_source': this.readCookie('utm_source'),
        'utm_medium': this.readCookie('utm_medium'),
        'utm_campaign': this.readCookie('utm_campaign'),
        'utm_adgroup': this.readCookie('utm_adgroup'),
        'gclid': this.readCookie('gclid'),
        'ga_client_id': this.readCookie('ga_client_id'),
        'unique_event_id': 'id' + Date.now().toString(),
        'form-id': 'request-a-quote',
      };

      await this.sendQuoteEvent(eventProperties);

      try {
        if (typeof klaviyo !== 'undefined' && typeof klaviyo.identify === 'function') {
          klaviyo.identify({
            email: this.selectors.form.elements.email.value,
            first_name: this.selectors.form.elements.name.value,
          });
        }
      } catch (err) {
        console.warn('Onsite Klaviyo identify skipped:', err);
      }

      this.cleanForm();
    } catch (err) {
      console.error('Quote submit failed:', err);
      this.showError(this.selectors.form.elements.email, 'Something went wrong. Please try again.');
    } finally {
      this.isSubmitting = false;
      this.selectors.form.classList.remove('_loading');
    }
  }

  cleanForm() {
    if(!this.selectors.form) {
      return;
    }

    Array.from(this.selectors.form.elements).forEach((item) => {
      if(item.name !== 'mtn-quote-submit') {
        item.value = '';
      }
    });

    this.selectors.modal.classList.remove('_active');
    this.selectors.modalSuccess.classList.add('_active');
  }

  addRemoveFromQuote(productData, rerender = true) {
    const product = this.products.find((product) => product.id === productData.productId);
    if(product) {
      product.active = !product.active;
    } else {
      this.products.push({
        id: productData.productId,
        url: productData.productUrl,
        variantId: productData.variantId,
        title: productData.productTitle,
        image: productData.productImage,
        sku: productData.productSku,
        quantity: 1,
        active: true
      });
    }

    window.localStorage.setItem(this.PRODUCTS_KEY, JSON.stringify(this.products));
    this.updateState(rerender);
  }

  updateState(rerender = true) {
    this.getState();
    this.setCount();
    this.updateButtonsStatus();
    if(this.count) {
      this.selectors.modalFormClear && this.selectors.modalFormClear.classList.remove('_hidden');
      this.selectors.modalFormShow && this.selectors.modalFormShow.classList.remove('_hidden');
    } else {
      this.selectors.modalFormClear && this.selectors.modalFormClear.classList.add('_hidden');
      this.selectors.modalFormShow && this.selectors.modalFormShow.classList.add('_hidden');
    }
    if(rerender) {
      this.renderProducts();
    }
  }

  updateButtonsStatus() {
    const addToQuoteButtons = document.querySelectorAll('.mtn-quote-add-to-quote, .mtn-quote-add-to-quote-button');
    addToQuoteButtons.forEach((addToQuoteBtn) => {
      const savedProduct = this.products.find((product) => product.id === addToQuoteBtn.dataset.productId);
      if(savedProduct && savedProduct.active) {
        addToQuoteBtn.classList.add('_active')
      } else {
        addToQuoteBtn.classList.remove('_active')
      }
    });
  }

  getState() {
    const storageProducts = window.localStorage.getItem(this.PRODUCTS_KEY);
    if(!storageProducts) {
      window.localStorage.setItem(this.PRODUCTS_KEY, JSON.stringify([]));
    }
    this.products = JSON.parse(storageProducts || "[]");
  }

  updateQuantity(id, qty, input) {
    const product = this.products.find((product) => product.id === id);

    if(qty > 0) {
      product.quantity = qty;
      window.localStorage.setItem(this.PRODUCTS_KEY, JSON.stringify(this.products));
      this.updateState(false);

      input.value = qty;
    }
  }

  renderProducts() {
    if(!this.selectors.productContainer) {
      return;
    }

    if(this.products.filter((i)=>i.active).length) {
      this.selectors.emptyState.classList.remove('_active');
      this.selectors.productContainer.classList.add('_active');
    } else {
      this.selectors.emptyState.classList.add('_active');
      this.selectors.productContainer.classList.remove('_active');
    }

    const products = document.createElement('div');
    products.classList.add('mtn-quote-list__list')

    this.products.forEach((function(product) {
      if(!product.active) {
        return;
      }

      const productCard = document.createElement('div');
      productCard.classList.add('mtn-quote-list__item');

      const productImage = document.createElement('img');
      productImage.classList.add('mtn-quote-list__image');
      productImage.src = product.image;

      const productTitle = document.createElement('div');
      productTitle.classList.add('mtn-quote-list__title');
      productTitle.textContent = product.title;

      const productCounterWrapper = document.createElement('div');
      productCounterWrapper.classList.add('mtn-quote-list__counter-wrapper');

      const productCounter = document.createElement('div');
      productCounter.classList.add('mtn-quote-list__counter');

      const input = document.createElement('input');
      input.classList.add('mtn-quote-list__counter-input');
      input.value = product.quantity;
      input.addEventListener('change', (function () {
        this.updateQuantity(product.id, parseInt(input.value), input);
      }).bind(this));

      const btnMinus = document.createElement('button');
      btnMinus.classList.add('mtn-quote-list__counter-btn');
      btnMinus.type = 'button';
      btnMinus.innerHTML = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-minus" viewBox="0 0 22 3"><path fill="currentColor" d="M21.5.5v2H.5v-2z" fill-rule="evenodd"></path></svg>`;
      btnMinus.addEventListener('click', (function () {
        this.updateQuantity(product.id, parseInt(input.value) - 1, input);
      }).bind(this));

      const btnPlus = document.createElement('button');
      btnPlus.classList.add('mtn-quote-list__counter-btn');
      btnPlus.type = 'button';
      btnPlus.innerHTML = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 22 21"><path d="M12 11.5h9.5v-2H12V0h-2v9.5H.5v2H10V21h2v-9.5z" fill="currentColor" fill-rule="evenodd"></path></svg>`;
      btnPlus.addEventListener('click', (function () {
        this.updateQuantity(product.id, parseInt(input.value) + 1, input);
      }).bind(this));

      productCounter.append(btnMinus);
      productCounter.append(input);
      productCounter.append(btnPlus);
      productCounterWrapper.append(productCounter);

      const productRemove = document.createElement('div');
      productRemove.classList.add('mtn-quote-list__remove');
      productRemove.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.54876 1.54878L18.4511 18.4511" stroke="#3D3D3D" stroke-width="2.15311" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M18.4511 1.54888L1.54879 18.4512" stroke="#3D3D3D" stroke-width="2.15311" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>`;

      productRemove.addEventListener('click', (function () {
        this.addRemoveFromQuote({
          productId: product.id,
        }, false);


        if(!this.products.filter((i)=>i.active).length) {
          this.selectors.emptyState.classList.add('_active');
          this.selectors.productContainer.classList.remove('_active');
        }

        productCard.remove();
      }).bind(this));

      productCard.append(productImage, productTitle, productCounterWrapper, productRemove);

      products.append(productCard)
    }).bind(this));

    this.selectors.productContainer.innerHTML = '';
    this.selectors.productContainer.append(products);
  }

  setCount() {
    if(this.selectors.count) {
      const productsCount = this.products.reduce((acc, now) => now.active ? acc+now.quantity : acc, 0);
      this.count = productsCount;

      if(productsCount) {
        this.selectors.count.forEach((count) => count.classList.add('_active'));
      } else {
        this.selectors.count.forEach((count) => count.classList.remove('_active'));
      }

      this.selectors.count.forEach((count) => count.textContent = `(${productsCount})`);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MtnQuote();
});